export default __webpack_public_path__ + "static/media/profile.576eb6a3.png";